import { Controller } from "@hotwired/stimulus"

// Manages field configuration for reference groups
export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_FIELD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const field = event.target.closest("[data-field-config-item]")
    if (field) {
      const destroyInput = field.querySelector("input[name*='_destroy']")
      if (destroyInput) {
        destroyInput.value = "1"
        field.style.display = "none"
      } else {
        field.remove()
      }
    }
  }

  typeChanged(event) {
    const field = event.target.closest("[data-field-config-item]")
    const optionsContainer = field.querySelector("[data-options-container]")
    if (optionsContainer) {
      optionsContainer.style.display = event.target.value === "select" ? "block" : "none"
    }
  }
}
